
<div :style="bannerStyle" :class="['banner', bannerClass(banner.status), banner.class]" v-if="banner.isShow">
  <div class="d-flex align-items-center"><b>{{ banner.text }}</b></div>
</div>
